import { Controller } from "@hotwired/stimulus"

// Attached to the job-detail "Apply to role" link. On click it does NOT
// preventDefault — the <a target="_blank"> still opens the employer page in a
// new tab — it just dispatches a window event to open the "Did you apply?"
// modal in the current tab (mirrors the upgrade-modal trigger pattern).
export default class extends Controller {
  open() {
    window.dispatchEvent(new CustomEvent("apply-confirm:open"))
  }
}
